const menuItems = [
  {
    text: 'Search by Map',
    value: 'map-page'
  },{
    text: 'Search by Tax Number',
    value: 'search-results-page'
  },{
    text: 'Search by Owner Name',
    value: 'search-results-page'
  },{
    text: 'Search by Address',
    value: 'search-results-page'
  },{
    text: 'Search for Current Location',
    value: 'map-page'
  },{
    text: 'Notes',
    value: 'notes-page'
  },{
    text: 'Video Tutorial',
    value: 'tutorial-page'
  },{
    text: 'if you are having trouble...',
    value: 'help-page'
  }
];

export default menuItems;
